import { render, staticRenderFns } from "./VFatherProAnamCAxARP.vue?vue&type=template&id=0d8c49a9"
import script from "./VFatherProAnamCAxARP.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxARP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports